import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto-js'

// var baseurl = 'https://forumnewapi-dev.fgcq.info'; //开发环境
var baseurl = 'https://forumnewapi.fgcq.info'; //测试环境
// var baseurl = 'https://bbsnewapi.3975bbs.com'  //正式环境
// var baseurl = 'https://bbsnewapi-pre.3975bbs.com' //预发布环境
const baseURL = process.env.NODE_ENV !== 'development' ? process.env.VUE_APP_INIT :
  baseurl

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

// const MD5 = (value) => {
//   console.log(crypto.get(value));
//   return crypto.get(value)
// }
const MD5 = (value) => {
  return crypto.MD5(value).toString()
}
function getCookie(name) {
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}


const sign = (params = {}) => {
  const keys = Object.keys(params).sort()
  const signs = []
  for (let key of keys) {
    if (params[key] == null) continue
    signs.push(`${key}=${params[key]}`)
  }
  signs.push(`key=Mjg3NTg0NDI`)
  return MD5(signs.join('&'))
}

const httpRequest = ({ method = 'GET', url = '', headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest()
  return new Promise((resolve, reject) => {
    xhr.open(method, baseURL + url, true)
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value)
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response))
      } else {
        resolve({ msg: xhr.statusText });
      }
    }
    xhr.send(body)
  })
}
const http = ({ method = 'GET', url = '', headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest()
  return new Promise((resolve, reject) => {
    xhr.open(method, base + url, true)
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value)
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response))
      } else {
        resolve({ msg: xhr.statusText });
      }
    }
    xhr.send(body)
  })
}

const instance = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: false,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
  transformRequest: data => qs.stringify(data)
})


// 添加响应拦截器
instance.interceptors.response.use(response => {
  const { status, data } = response;

  if (status === 200) {
    // 未登录，未授权
    if (data.code === 402 || data.code == 401) {
      // uni.$toast(data.msg);
      // store.dispatch('logout');
      // store.commit('popup/setloginpop', true)
    }
    // 账号被封禁
    else if (data.code === 408) {
      // if (!store.state.popup.forbid) {
      //   // uni.$c.sealGamePopup({ flag: true, data: data.data })
      // }

    }
    // 强制更新
    else if (data.code === 403) {

    }
    return data;
  } else {
    return Promise.reject(new Error('Server Unknown Error'));
  }
}, error => {
  // if (error.toString() != 'Error: Network Error') {
  //   store.dispatch('pushError', error.toString())
  // }
  return Promise.resolve(error)
})



const Ajax = async (url, data = {}, conf = {}) => {

  // js获取设备类型
  let ua = navigator.userAgent.toLowerCase();
  let isAndroid = ua.indexOf("android") > -1;
  let isIos = ua.indexOf("iphone") > -1;
  var platform = 'pc'
  if (isAndroid) {
    platform = 'android'
  } else if (isIos) {
    platform = 'ios'
  }

  let rs
  // || url == 'login-with-code'
  var params = {}
  rs = await instance({
    url,
    method: 'post',
    headers: {
      platform,
    },
    data: {
      ...data,
      ...params,
      sign: sign({ ...data }),
    },

    ...conf
  })
  return rs
}

// 将axios挂载到Vue原型上，方便在组件中使用
Vue.prototype.$ajax = Ajax
export { baseURL, Ajax, httpRequest, MD5, http }
export default Ajax
